import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

export default function SellerDashboard() {
  const [products, setProducts] = useState([]);

  // ✅ Fetch Seller Products
  useEffect(() => {
    async function fetchProducts() {
      try {
        const token = localStorage.getItem("sellerToken");

        if (!token) {
          console.log("Seller not logged in");
          return;
        }

        const res = await axios.get("https://haaterkaj-backend-1.onrender.com/api/seller/my-products", {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });

        if (res.data.success) {
          setProducts(res.data.products);
        }
      } catch (err) {
        console.error("Error fetching products:", err);
      }
    }

    fetchProducts();
  }, []);

  // ✅ Delete product
  const deleteProduct = async (id) => {
    try {
      const token = localStorage.getItem("sellerToken");

      if (!token) {
        alert("Seller not logged in");
        return;
      }

      const res = await axios.delete(`https://haaterkaj-backend-1.onrender.com/api/seller/delete/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      alert(res.data.message);
      setProducts(products.filter((p) => p._id !== id));
    } catch (err) {
      console.error(err);
      alert("Failed to delete product");
    }
  };

  return (
    <div className="max-w-5xl mx-auto p-6">
      <h2 className="text-2xl font-bold mb-6 text-amber-800">Seller Dashboard</h2>

      <div className="text-right mb-4">
        <Link
          to="/seller/add-product"
          className="bg-amber-600 text-white px-4 py-2 rounded hover:bg-amber-700"
        >
          + Add New Product
        </Link>
      </div>

      {products.length === 0 ? (
        <p className="text-center text-gray-500">No products yet. Start adding!</p>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
          {products.map((p) => (
            <div key={p._id} className="border p-4 rounded shadow-sm">
              <img
                src={`https://haaterkaj-backend-1.onrender.com${p.image}`}
                alt={p.name}
                className="w-full h-40 object-cover rounded mb-3"
              />

              <h3 className="text-lg font-semibold">{p.name}</h3>
              <p className="text-sm text-gray-600">{p.place}</p>
              <p className="font-bold mt-2 text-amber-700">₹ {p.price}</p>

              <ul className="text-sm text-gray-700 mt-2">
                {p.features?.length > 0 ? (
                  p.features.map((f, i) => <li key={i}>• {f}</li>)
                ) : (
                  <li>No features listed</li>
                )}
              </ul>

              {/* Buttons */}
              <div className="flex gap-3 mt-4">
                <button
                  onClick={() => deleteProduct(p._id)}
                  className="w-full bg-red-500 text-white py-2 rounded-lg hover:bg-red-600"
                >
                  Delete
                </button>

                <Link
                  to={`/edit-product/${p._id}`}
                  className="w-full bg-blue-600 text-white py-2 rounded-lg text-center hover:bg-blue-700"
                >
                  Edit
                </Link>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
